import './library/anchor4'
import './library/ajax4'
import './library/debug4'
import './library/delay4'
import './library/detect4'
import './library/resize4'
import './library/scroll4'
import './library/scrollCss4'
import './library/parallax4'
import './library/aost4'
import './library/sticky4'
import './library/tab4'
import './plugin/video4'
import './plugin/swiper4'
import './component/article4'

// version info
(function() {
    "use strict"
    fesdDB.ver.fesd = { ver: '2.0', update: '20210203' }
})()